import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin } from 'react-icons/fa';
// import { SiGmail } from 'react-icons/si';

export const Contact = () => {
  // const handleGmailClick = (e) => {
  //   e.preventDefault();
  //   window.open('https://mail.google.com/mail/?view=cm&fs=1&to=YOUR_EMAIL_ADDRESS', '_blank');
  // };

  return (
    <section
      id="contact"
      className="min-h-screen flex items-center justify-center py-24 sm:py-32"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="space-y-12"
        >
          <div>
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-white mb-4"
              style={{ fontFamily: 'Outfit' }}
              data-testid="contact-heading"
            >
              Get In Touch
            </h2>
            <p className="text-base leading-relaxed text-slate-300" style={{ fontFamily: 'IBM Plex Sans' }}>
              Connect with me on LinkedIn
            </p>
          </div>

          <div className="flex justify-center items-center space-x-8">
            <motion.a
              href="https://www.linkedin.com/in/melvin-nigel-ferdion/"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, y: -8 }}
              transition={{ duration: 0.2 }}
              className="flex flex-col items-center space-y-4 p-8 bg-slate-900/30 border border-white/5 hover:border-emerald-500/30 transition-all duration-300 ease-out group"
              data-testid="linkedin-link"
            >
              <div className="w-20 h-20 bg-emerald-600/10 border border-emerald-500/20 rounded-sm flex items-center justify-center group-hover:bg-emerald-600/20 transition-colors duration-300">
                <FaLinkedin className="w-10 h-10 text-emerald-500" />
              </div>
              <span className="text-slate-300 font-medium" style={{ fontFamily: 'IBM Plex Sans' }}>
                LinkedIn
              </span>
            </motion.a>

            {/* <motion.a
              href="#"
              onClick={handleGmailClick}
              whileHover={{ scale: 1.1, y: -8 }}
              transition={{ duration: 0.2 }}
              className="flex flex-col items-center space-y-4 p-8 bg-slate-900/30 border border-white/5 hover:border-red-500/30 transition-all duration-300 ease-out group cursor-pointer"
              data-testid="gmail-link"
            >
              <div className="w-20 h-20 bg-red-600/10 border border-red-500/20 rounded-sm flex items-center justify-center group-hover:bg-red-600/20 transition-colors duration-300">
                <SiGmail className="w-10 h-10 text-red-500" />
              </div>
              <span className="text-slate-300 font-medium" style={{ fontFamily: 'IBM Plex Sans' }}>
                Gmail
              </span>
            </motion.a> */}
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="pt-12 border-t border-white/5"
          >
            <p className="text-sm text-slate-500" style={{ fontFamily: 'IBM Plex Sans' }}>
              © {new Date().getFullYear()} melvinnigel.my.id
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
